let env_type = process.env.NODE_ENV || 'production';

if (
	window.location.host.startsWith('dev') ||
	window.location.host.startsWith('viewers-ev') ||
	window.location.host.startsWith('app.sandbox') ||
	window.location.host.startsWith('dashboard.sandbox') ||
	window.location.host.startsWith('localhost') ||
	window.location.host.startsWith('sandbox')
) {
	env_type = 'development';
}

export const EVENT_IMAGES = {
	BANNER:
		'https://static.eventovirtual.co/v1/AUTH_93e97be4d41e467687f422fd1a8ce372/eventovirtual-public/events/NOT_EVENT/IMAGE/BANNER.png',
	EVENT_AVATAR:
		'https://static.eventovirtual.co/v1/AUTH_93e97be4d41e467687f422fd1a8ce372/eventovirtual-public/events/NOT_EVENT/IMAGE/EVENT_AVATAR.png',
	ORGANIZER_AVATAR:
		'https://static.eventovirtual.co/v1/AUTH_93e97be4d41e467687f422fd1a8ce372/eventovirtual-public/events/NOT_EVENT/IMAGE/ORGANIZER_AVATAR.png',
	PLAYER_BACKGROUND:
		'https://static.eventovirtual.co/v1/AUTH_93e97be4d41e467687f422fd1a8ce372/eventovirtual-public/resources/logos/estatica.jpg',
	PLAYER_ICON:
		'https://static.eventovirtual.co/v1/AUTH_93e97be4d41e467687f422fd1a8ce372/eventovirtual-public/resources/logos/isologo-eventovirtual-30x30.png',
};

const viewer_zone_domain = {
	development: 'https://app.sandbox.eventovirtual.co',
	dashboard_development: 'https://dashboard.sandbox.eventovirtual.co',
	production: 'https://app.eventovirtual.co',
	dashboard_production: 'https://dashboard.eventovirtual.co',
};

export const ASSETS_SERVER_PATH =
	'https://static.eventovirtual.co/v1/AUTH_93e97be4d41e467687f422fd1a8ce372/eventovirtual-public/';

export const MOMENT_SPANISH_LANG = {
	months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split(
		'_'
	),
	monthsShort: 'Enero._Feb._Mar_Abr._May_Jun_Jul._Ago_Sept._Oct._Nov._Dec.'.split(
		'_'
	),
	weekdays: 'Domingo_Lunes_Martes_Miercoles_Jueves_Viernes_Sabado'.split('_'),
	weekdaysShort: 'Dom._Lun._Mar._Mier._Jue._Vier._Sab.'.split('_'),
	weekdaysMin: 'Do_Lu_Ma_Mi_Ju_Vi_Sa'.split('_'),
};

export const _AVATAR_ =
	'https://static.eventovirtual.co/v1/AUTH_93e97be4d41e467687f422fd1a8ce372/eventovirtual-public/resources/logos/Edit%20User%20Male.svg';

export const _VIDEO_SERVER_ = '1566626989_2ZWqtfdRrxCA';

export const VIEWER_ZONE_DOMAIN = viewer_zone_domain[env_type];
export const DASHBOARD_ZONE_DOMAIN = viewer_zone_domain[`dashboard_${env_type}`];
